import React from "react";
import '../CSS/Card.css'

export default function Card({children}) {
    return (
        <div className="card">
            {children}
        </div>
    );
}